module.exports = __webpack_public_path__ + "static/img/2ao.97cd2b84.webp";